var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"record-container"},[_c('div',{staticClass:"record-content"},[_c('span',{staticClass:"record-primary"},[_vm._v(_vm._s(_vm.primary)+" ")]),_c('br'),_c('span',{staticClass:"record-secondary"},[_vm._v(" "+_vm._s(_vm.secondary)+" ")])]),_c('div',{staticClass:"small-status"},[_c('GcSmallStatus',{attrs:{"status":_vm.status}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }